<template>
  <image-field
    :src="srcVal"
    max-width="20"
    height="20"
    class="cell-icon"
    contain
  />
</template>

<script>
import ImageField from '@/global/components/fields/ImageField.vue'

export default {
  name: 'ActiveIcon',

  components: {
    ImageField
  },

  props: {
    cellData: {
      type: String,
      default: null
    },
    config: {
      type: Object,
      default: () => ({})
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      srcVal: undefined
    }
  },

  watch: {
    cellData: {
      immediate: true,
      handler (val) {
        const { src } = this.config || {}

        if (src && typeof src === 'string') {
          this.srcVal = src
        }
        else if (typeof src === 'function') {
          this.srcVal = src({
            changeSrc: (src) => this.changeSrc(src)
          })
        }
      }
    }
  },

  methods: {
    changeSrc (src) {
      if (src && typeof src === 'string') {
        this.srcVal = src
      }
    }
  }
}
</script>

<style scoped>
.cell-icon {
  cursor: pointer;
}
</style>
